var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"transform":("rotate(-90, " + _vm.cx + ", " + _vm.cy + ")")}},[_c('path',{attrs:{"fill":_vm.arc_color,"fill-opacity":_vm.fill_opacity,"stroke":"black","stroke-width":"0.2","d":_vm.arc()}})])}
var staticRenderFns = []

export { render, staticRenderFns }